import { CART_MODULE } from "@/api_framework/api_config";
import { ICartDetailsResponseData } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useUserInvoiceStatusList = () => {
  const configuration = useConfiguration();
  const [invoiceStatus, setInvoiceStatus] = useState<any>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: ICartDetailsResponseData | null = await axios
        .get(`${CART_MODULE?.INVOICE_STATUS_API?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<any>) => {
          if (res.data.status === true) {
            setInvoiceStatus(res.data.data);

            return res.data.data;
          } else {
            setInvoiceStatus([]);

            return null;
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          setInvoiceStatus([]);
          captureError(e);

          return null;
        });
      return response;
    } catch (e) {
      setInvoiceStatus([]);
      captureError(e);
    }
  }, [dispatch]);
  return { invoiceStatus, execute };
};
